import { Heading, Icon, Theme, useStyles } from 'bold-ui'
import { ColorScale, gray } from 'bold-ui/lib/styles/colors'
import { AccordionAnimation } from 'components/accordion/AccordionAnimation'
import { AccordionButton } from 'components/accordion/AccordionButton'
import React, { CSSProperties } from 'react'
import { AccordionItemPanel } from 'react-accessible-accordion'

export interface SoapSectionProps {
  title: React.ReactNode
  initial: string
  color?: ColorScale
  children: React.ReactNode
}

export function SoapSection(props: SoapSectionProps) {
  const { title, initial, children } = props
  const { classes } = useStyles(createStyles, props.color)

  return (
    <AccordionAnimation>
      <AccordionButton>
        <div className={classes.header}>
          <span className={classes.initial}>{initial}</span>
          <Heading level={2} style={classes.title}>
            {title}
          </Heading>
          <Icon icon='angleDown' size={1.5} className={classes.icon} />
        </div>
      </AccordionButton>

      <AccordionItemPanel>
        <div className={classes.content}>{children}</div>
      </AccordionItemPanel>
    </AccordionAnimation>
  )
}

SoapSection.defaultProps = {
  color: gray,
}

const createStyles = (theme: Theme, color: ColorScale) => ({
  header: {
    ...theme.typography.variant('h2'),
    display: 'flex',
    borderRadius: 2,
    background: color.c90,
    '&:hover': {
      backgroundColor: color.c80,
    },
  } as CSSProperties,
  initial: {
    background: color.c40,
    color: theme.pallete.gray.c100,
    borderRadius: 4,
    padding: '0.25rem 0.75rem',
  } as CSSProperties,
  title: {
    flex: 1,
    padding: '0.25rem 0.75rem',
  } as CSSProperties,
  icon: {
    alignSelf: 'center',
    marginRight: '0.5rem',
  } as CSSProperties,
  content: {
    padding: '1rem 0.3rem',
  } as CSSProperties,
})
